import Vue from "vue";
import Vuelidate from "vuelidate";
import VueMeta from "vue-meta";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import { LiveChatWidget } from "@livechat/widget-vue/v2";
// import "./registerServiceWorker";
import i18n from "@/i18n";
import helpers from "@/plugins/helpers";
import VueSweetalert2 from "vue-sweetalert2";
import VueResource from "vue-resource";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment-timezone";
moment.tz.setDefault("Asia/Kuala_Lumpur");
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
import numeral from "numeral";
Object.defineProperty(Vue.prototype, "$numeral", { value: numeral });

import VueFlashMessage from "vue-flash-message";
Vue.use(VueFlashMessage);

import VLazyImage from "v-lazy-image/v2";
Vue.component("VLazyImage", VLazyImage);

// import "vue-draggable-resizable/dist/VueDraggableResizable.css";

Vue.use(VueResource);

Vue.config.productionTip = false;
Vue.config.productionTip = process.env.NODE_ENV === "production" || false;

Vue.use(helpers, { $swal: Vue.swal, $moment: moment, $router: router, $store: store });
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueResource);
Vue.use(datePicker);
Vue.use(VueMeta)
// Vue.use(LiveChatWidget)

router.beforeEach((to, from, next) => {
  let query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath };
  if (
    to.matched.some(record => {
      return record.meta.requiredLoggedIn;
    })
  ){
    if (!store.getters.isLoggedIn) {
      // next({ path: path, query: query });
      next({ path: ""});
      return;
    }
  }

  if (
    to.matched.some(record => record.meta.beforeLoggedIn)
  ) {
    if (store.getters.isLoggedIn) {
      next({ path: "" });
      return;
    }
  }

  next();
})

// router.afterEach((to, from) => {
//   console.log(`Navigated from ${from.fullPath} to ${to.fullPath}`);
//   if(from.fullPath != to.fullPath){
//     const postData = {
//       routeChange: true,
//       routeFrom: from.fullPath,
//       routeTo: to.fullPath,
//     };
//     // Send a POST request to the ASPX page when a route change occurs
//     Vue.http.post('../public/Default.aspx/RouteChange', postData)
//     .then((response) => {
//       console.log('testt', to.path, from.fullPath); // Server response, if any
//     })
//     .catch((error) => {
//       console.error(error, 'errorr');
//     });
//   }
  
// });

i18n.locale = store.state.user.language;

new Vue({
  router,
  store,
  i18n,
  mounted(){
    document.dispatchEvent(new Event('render-event'))
  },
  render: h => h(App),
  
}).$mount("#app");
